import authApi from "../../utils/AxiosConfig";
import authHeader from "../../utils/authHeader";

const API_URL = "/business"; // Base URL for the business-related endpoints

// Fetch all businesses
const fetchBusinesses = async (token: string) => {
    const response = await authApi.get(API_URL, {
        headers: authHeader(token),
    });
    return response.data;
};

// Fetch a single business by ID
const fetchBusinessById = async (id: string, token: string) => {
    const response = await authApi.get(`${API_URL}/${id}`, {
        headers: authHeader(token),
    });
    return response.data;
};

// Create a new business
const createBusiness = async (formData: any, token: string) => {
    const response = await authApi.post(API_URL, formData, {
        headers: authHeader(token),
    });
    return response.data;
};

// Update an existing business
const updateBusiness = async (id: string, formData: any, token: string) => {
    const response = await authApi.put(`${API_URL}/${id}`, formData, {
        headers: authHeader(token),
    });
    return response.data;
};

// Delete a business
const deleteBusiness = async (id: string, token: string) => {
    const response = await authApi.delete(`${API_URL}/${id}`, {
        headers: authHeader(token),
    });
    return response.data;
};

// Upload images
const uploadImages = async (files: File[], token: string, onProgress?: (progress: number) => void) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("uploadedImages", file));

    const response = await authApi.post(`${API_URL}/upload-images`, formData, {
        headers: {
            ...authHeader(token),
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (event) => {
            if (onProgress) {
                const percentage = Math.round((event.loaded * 100) / event.total);
                onProgress(percentage);
            }
        },
    });

    return response.data.uploadedImages;
};



const businessService = {
    fetchBusinesses,
    fetchBusinessById,
    createBusiness,
    updateBusiness,
    deleteBusiness,
    uploadImages,
};

export default businessService;
